<template>
  <div class="ph-wrap">
    <div class="ph-card" :class="{ focused }">
      <div class="ph-inner">
        <div class="ph-icon" aria-hidden="true">
          <img src="../assets/icons/reg.svg" alt="" />
        </div>

        <div class="ph-title">
          Anda belum terdaftar sebagai Anggota Perindo
        </div>

        <div class="ph-subtitle">
          Klik tombol di bawah untuk mendaftar sebagai anggota
        </div>

        <router-link class="ph-cta" to="/form-registrasi">
          <button class="ph-btn" type="button">
            Daftar Menjadi Anggota Perindo Sekarang
          </button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'NewCardPlaceholder',
}
</script>

<style lang="scss" scoped>
.ph-wrap {
  position: relative;
}

/* card container */
.ph-card {
  width: 100%;
  position: relative;
}

.ph-card.focused {
  z-index: 99999;
}

.ph-inner {
  background: #ffffff;
  border-radius: 14px;
  border: 1px solid #e5e7eb;

  padding: 34px 24px;
  text-align: center;
}

.ph-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 64px;
}

.ph-title {
  font-size: 18px;
  line-height: 1.25;
  font-weight: 700;
  color: #111827;
  margin-bottom: 10px;
}

.ph-subtitle {
  font-size: 14px;
  line-height: 1.45;
  color: #393B4A;
  margin-bottom: 55px;
}

/* CTA */
.ph-cta {
  display: block;
}

.ph-btn {
  width: 100%;
  border: none;
  border-radius: 8px;
  background: #243b7a;
  color: #fff;

  font-weight: 600;
  font-size: 16px;
  padding: 20px 16px;
  cursor: pointer;

  transition: transform 0.06s ease, filter 0.15s ease;
}

.ph-btn:hover {
  filter: brightness(1.05);
}

.ph-btn:active {
  transform: translateY(1px);
}

/* tooltip banner lama */
.textTooltip {
  position: absolute;
  top: 50%;
  right: -100%;
  width: 100%;
  font-size: 16px;
  font-weight: bold;
  transform: translateY(-50%);
  z-index: 100000;
  color: #fff;

  @media only screen and (max-width: 1024px) {
    top: 160%;
    right: 0;
  }
}

/* mobile */
@media only screen and (max-width: 600px) {
  .ph-inner {
    padding: 28px 16px;
  }

  .ph-title {
    font-size: 20px;
  }

  .ph-subtitle {
    font-size: 14px;
  }

  .ph-btn {
    font-size: 16px;
  }
}
</style>
